import React from 'react';

import { ListGroup } from 'react-bootstrap';
import styles from './Onboarding.module.css';

const getTextColor = isHighLight => (isHighLight ? '#EB0000' : '#000000');

export default ({ results }) => {
  if (Object.keys(results).length === 0) return null;

  return (
    <div style={{ marginTop: '2em' }}>
      <div>
        <div
          className={styles.risk_recommendation_title}
          style={{ marginBottom: '12px', marginTop: '20px' }}
        >
          {results.primary_action.text}
        </div>

        <div>
          <ListGroup style={{ marginBottom: '3.750em' }}>
            {results.meta_data.display_data.questions.map(item => (
              <ListGroup.Item
                variant="light"
                style={{ outline: 'none', padding: '1em' }}
                key={item.header}
                action
                className="list-group-item-warning"
                onCopy={e => e.preventDefault()}
              >
                <div className="summary_question_answer_column">
                  <div className="summary_question_column">
                    {item.header}
                  </div>
                </div>
                <div
                  style={{
                    color: getTextColor(item.highlight),
                    fontFamily: 'JioType-Medium',
                    fontSize: '14px'
                  }}
                >
                  <div style={{
                    display: 'flex',
                    flexFlow: 'row',
                    justifyContent: 'right'
                  }}
                  >
                    {item.data.map(ans => (
                      <span
                        key={ans}
                        style={{
                          padding: '5px'
                        }}
                      >
                        {ans}
                      </span>
                    ))}
                  </div>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      </div>
    </div>
  );
};
